// i18n dictionary for RPLC UAE. English + Arabic (RTL).
// Only UI chrome is translated; long-form editorial copy remains bilingual per business decision.

export const TRANSLATIONS = {
  en: {
    dir: "ltr",
    lang: "en",
    nav: {
      home: "Home",
      about: "About",
      practice: "Practice",
      team: "Team",
      insights: "Insights",
      contact: "Contact",
      consult: "Consult",
      menu: "Menu",
    },
    hero: {
      eyebrow: "RPLC UAE · Rane Pingle Law Chambers",
      l1: "Technology.",
      l2a: "Regulation.",
      l2b: "Business.",
      l3: "Across",
      l4a: "borders.",
      l4b: "",
      lead: "RPLC UAE is a modern legal & business consultancy at the intersection of Law × Technology × Regulation × Business. We advise founders, technology companies, financial businesses and multinationals across UAE, India and USA.",
      ctaPrimary: "Request a consultation",
      ctaGhost: "Fields of expertise",
      scroll: "Scroll",
    },
    marquee: [
      "Cyber Crime · Digital Fraud",
      "VARA · Virtual Assets",
      "Economic Offences",
      "Data Privacy · PDPL",
      "CFD · Trading Disputes",
      "AI Governance",
      "FinTech · Capital Markets",
      "Fractional General Counsel",
      "India Entry · FEMA",
      "DIFC · ADGM",
      "UAE × India × USA",
    ],
    manifesto: {
      eyebrow: "Manifesto — four chapters",
      chapterOf: "Chapter · {n} of 04",
    },
    practice: {
      eyebrow: "Fields of expertise",
      title1: "Fifteen",
      title2: "disciplines,",
      title3: "one bench.",
      all: "All practice areas",
      featured: "Featured",
    },
    cyberSpotlight: {
      tag: "Featured practice · 01",
      eyebrow: "Cyber Crime & Digital Fraud",
      title1: "When the crime",
      title2: "is digital,",
      title3: "counsel must be too.",
      lead: "Led by Rajas Pingle, the Cyber Crime practice sits at the centre of the bench: complaints and defence under the UAE Cybercrime Law and India's IT Act, fraud and crypto-scam recovery, trading-platform fraud, incident response and forensics, coordinated with Cyber Cell, Public Prosecution and registered advocates.",
      lead_label: "Practice lead",
      profile: "View profile",
      cta: "Speak to the cyber team",
      ctaGhost: "All fifteen practice areas",
    },
    careersForm: {
      apply: "Apply",
      applyingFor: "Applying for",
      name: "01 — Full name",
      namePh: "Your name",
      email: "02 — Email",
      emailPh: "you@example.com",
      phone: "03 — Phone (optional)",
      phonePh: "+971 …",
      cover: "04 — Cover note (optional)",
      coverPh: "A few lines on why this role, and why now.",
      cv: "05 — CV / Résumé",
      cvHint: "PDF, DOC or DOCX · max 10MB",
      cvChoose: "Attach CV",
      cvChange: "Replace file",
      submit: "Submit application",
      sending: "Uploading…",
      sentTitle: "Application received",
      sentBody: "A founding partner will read it in confidence. We respond to every candidate we take forward.",
      err: "Name, email and CV are required.",
      errType: "CV must be a PDF, DOC or DOCX file.",
      errSize: "CV exceeds the 10MB limit.",
      toastOk: "Application received. Thank you.",
      toastFail: "Unable to submit. Please try again.",
      close: "Close",
      generalTitle: "General application",
      generalCta: "Send a general application",
      disclaimer: "By submitting, you consent to RPLC processing your application data in confidence for recruitment purposes only.",
    },
    heritage: {
      eyebrow: "The practice — four coordinates",
      title1: "One team,",
      title2: "four coordinates.",
      lead: "Coordinated advisory across UAE free zones and onshore jurisdictions, India-entry & FEMA/FDI, US commercial coordination — with formal representation handled through registered UAE advocates.",
    },
    team: {
      eyebrow: "Managing Partners",
      title1: "Counsel,",
      title2: "named.",
      full: "The full bench",
    },
    testimonials: {
      eyebrow: "Client confidence",
      title1a: "Trusted",
      title1b: "quietly",
      title2: "— and often.",
    },
    matters: {
      eyebrow: "Selected matters",
      title1: "The work,",
      title2: "on record.",
      lead: "A discreet, non-exhaustive selection of matters that illustrate the range of the practice. Client names withheld under counsel duties; details rendered indicative.",
      all: "View all matters",
    },
    insights: {
      eyebrow: "Latest insights",
      title1: "Reading,",
      title2: "between the codes.",
      all: "All insights",
      featured: "Featured",
      read: "Read the piece",
      back: "Back to insights",
    },
    clients: { eyebrow: "Selected clients" },
    contactCTA: {
      title1: "Begin an",
      title2: "engagement.",
      lead: "A discreet, no-obligation first conversation, usually within one working day.",
      cta: "Contact chambers",
    },
    contact: {
      eyebrow: "Make an inquiry",
      title1: "Begin an",
      title2: "engagement.",
      lead: "A discreet, no-obligation first conversation. Every message is read by a partner, usually within one working day.",
      name: "01 — Full name",
      namePh: "Your name",
      email: "02 — Email",
      emailPh: "you@example.com",
      business: "03 — Business (optional)",
      businessPh: "Company / organisation",
      message: "04 — Message",
      messagePh: "Tell us, briefly, what brings you to chambers.",
      submit: "Send message",
      sending: "Sending…",
      sent: "Sent",
      chambers: "Chambers",
      direct: "Direct",
      err: "Name, email and message are required.",
      okTitle: "Received",
      okBody: "A partner will be in touch shortly.",
      disclaimer: "By submitting, you acknowledge that no lawyer-client relationship is created by this website.",
      toastOk: "Message received. A partner will respond within one working day.",
      toastFail: "Unable to submit. Please try again.",
    },
    about: {
      eyebrow: "RPLC UAE · Rane Pingle Law Chambers",
      title1: "Law × Technology ×",
      title2: "Regulation × Business.",
      lead1: "RPLC UAE is a modern legal and business consultancy at the intersection of Law × Technology × Regulation × Business.",
      lead2: "We advise startups, technology companies, financial businesses, multinational corporations, investors and founders operating in and through the UAE, combining deep regulatory expertise with an understanding of the commercial realities shaping the digital economy.",
      lead3: "Our footprint spans UAE, India and USA, providing coordinated legal support as businesses expand, invest and operate across geographies. International work is provided as cross-border advisory and coordination with local counsel where required by applicable law.",
      stats: [
        { n: "03", l: "Jurisdictions" },
        { n: "15", l: "Practice areas" },
        { n: "02", l: "Founding partners" },
        { n: "03", l: "Local advocacy partners" },
      ],
      offices: { eyebrow: "Global footprint", title1: "Three markets,", title2: "one file." },
    },
    practicePage: {
      eyebrow: "Fields of expertise · 15",
      title1: "Fifteen disciplines,",
      title2: "one bench.",
      lead: "Every mandate is staffed by a partner and a small, dedicated team. No file is ever passed sideways; the counsel you brief is the counsel you keep.",
      close: "A discreet first conversation.",
    },
    practiceDetail: {
      back: "All practice areas",
      overview: "Overview",
      howWeWork: "How we work",
      services: "What we do",
      matters: "Indicative matters",
      mattersNote: "Client names withheld under counsel duties; details rendered indicative.",
      faqs: "Frequently asked questions",
      lead: "Practice lead",
      profile: "View profile",
      related: "Related practice areas",
      reading: "Related reading",
      focus: "Focus",
      ctaTitle1: "Speak to the",
      ctaTitle2: "practice.",
      ctaLead: "A discreet, no-obligation first conversation, usually within one working day. Urgent matters are triaged the same day.",
      cta: "Contact chambers",
      direct: "Direct",
      explore: "Explore the practice",
    },
    teamPage: {
      eyebrow: "The bench · Partners & Counsel",
      title1: "Counsel,",
      title2: "named.",
      close: "Brief the bench.",
    },
    footer: {
      eyebrow: "Law × Technology × Regulation × Business",
      title1: "Counsel,",
      title2: "clearly",
      title3: "coordinated.",
      lead: "RPLC UAE is a modern legal & business consultancy at the intersection of Law × Technology × Regulation × Business, across UAE, India and USA. Formal representation before UAE authorities is undertaken through registered Emirati advocacy partners.",
      cta: "Begin an engagement",
      practice: "Practice",
      offices: "Offices",
      disclaimer: "Under Bar Council rules, this website is for informational purposes only and does not constitute solicitation or advertising. Nothing transmitted here creates a lawyer-client relationship.",
    },
  },
  ar: {
    dir: "rtl",
    lang: "ar",
    nav: {
      home: "الرئيسية",
      about: "عن المكتب",
      practice: "الممارسات",
      team: "الفريق",
      insights: "المقالات",
      contact: "تواصل",
      consult: "استشارة",
      menu: "القائمة",
    },
    hero: {
      eyebrow: "RPLC UAE · مكتب رانِه بينغل للمحاماة",
      l1: "التكنولوجيا.",
      l2a: "التنظيم.",
      l2b: "الأعمال.",
      l3: "عبر",
      l4a: "الحدود.",
      l4b: "",
      lead: "RPLC UAE مكتب استشارات قانونيّة وأعماليّة حديث يعمل على تقاطع القانون × التكنولوجيا × التنظيم × الأعمال، يقدّم الاستشارة للمؤسسين والشركات التقنيّة والماليّة والشركات متعددة الجنسيات عبر الإمارات والهند والولايات المتحدة.",
      ctaPrimary: "اطلب استشارة",
      ctaGhost: "مجالات الخبرة",
      scroll: "تمرير",
    },
    marquee: [
      "الجرائم الإلكترونية · الاحتيال الرقمي",
      "الأصول الافتراضية · VARA",
      "الجرائم الاقتصادية",
      "خصوصية البيانات · PDPL",
      "منازعات التداول · CFD",
      "حوكمة الذكاء الاصطناعي",
      "التقنية الماليّة · أسواق المال",
      "مستشار عامّ جزئيّ",
      "الدخول إلى الهند · FEMA",
      "DIFC · ADGM",
      "الإمارات × الهند × الولايات المتحدة",
    ],
    manifesto: {
      eyebrow: "البيان، أربعة فصول",
      chapterOf: "فصل · {n} من ٠٤",
    },
    practice: {
      eyebrow: "مجالات الخبرة",
      title1: "خمسة عشر",
      title2: "تخصصاً،",
      title3: "منصة واحدة.",
      all: "جميع مجالات الممارسة",
      featured: "مميّز",
    },
    cyberSpotlight: {
      tag: "ممارسة مميّزة · ٠١",
      eyebrow: "الجرائم الإلكترونية والاحتيال الرقمي",
      title1: "حين تكون الجريمة",
      title2: "رقمية،",
      title3: "يجب أن يكون المحامي كذلك.",
      lead: "بقيادة راجاس بينغل، تقع ممارسة الجرائم الإلكترونية في قلب المكتب: الشكاوى والدفاع بموجب قانون الجرائم الإلكترونية الإماراتي وقانون تقنية المعلومات الهندي، واسترداد أموال الاحتيال والعملات المشفّرة، واحتيال منصات التداول، والاستجابة للحوادث والتحقيق الجنائي الرقمي، بالتنسيق مع الشرطة الإلكترونية والنيابة العامة والمحامين المسجّلين.",
      lead_label: "رئيس الممارسة",
      profile: "عرض الملف",
      cta: "تحدّث مع فريق الجرائم الإلكترونية",
      ctaGhost: "جميع مجالات الممارسة الخمسة عشر",
    },
    careersForm: {
      apply: "تقدّم",
      applyingFor: "التقديم لوظيفة",
      name: "٠١، الاسم الكامل",
      namePh: "اسمك",
      email: "٠٢، البريد الإلكتروني",
      emailPh: "you@example.com",
      phone: "٠٣، الهاتف (اختياري)",
      phonePh: "+971 …",
      cover: "٠٤، رسالة تعريفية (اختياري)",
      coverPh: "بضع كلمات عن سبب اختيارك لهذا الدور، ولماذا الآن.",
      cv: "٠٥، السيرة الذاتية",
      cvHint: "PDF أو DOC أو DOCX · بحدّ أقصى 10 ميغابايت",
      cvChoose: "إرفاق السيرة الذاتية",
      cvChange: "استبدال الملف",
      submit: "إرسال الطلب",
      sending: "جارٍ التحميل…",
      sentTitle: "تم استلام الطلب",
      sentBody: "سيقرأه أحد الشركاء المؤسّسين بسرّية. نردّ على كلّ مرشّح نمضي معه قدماً.",
      err: "الاسم والبريد والسيرة الذاتية حقول مطلوبة.",
      errType: "يجب أن تكون السيرة الذاتية بصيغة PDF أو DOC أو DOCX.",
      errSize: "حجم السيرة الذاتية يتجاوز 10 ميغابايت.",
      toastOk: "تم استلام الطلب. شكراً لك.",
      toastFail: "تعذّر الإرسال. يُرجى المحاولة مرة أخرى.",
      close: "إغلاق",
      generalTitle: "طلب عامّ",
      generalCta: "أرسل طلباً عامّاً",
      disclaimer: "بإرسالك هذا الطلب، توافق على معالجة RPLC لبيانات طلبك بسرّية لأغراض التوظيف فقط.",
    },
    heritage: {
      eyebrow: "الممارسة، أربع إحداثيّات",
      title1: "فريقٌ واحد،",
      title2: "أربع إحداثيّات.",
    lead: "من مكتب واحد في بونا إلى مقرٍّ عالميّ. إرثٌ بُني ببطء، على مهل، عميلاً عميلاً.",
    },
    team: {
      eyebrow: "الشركاء الإداريون",
      title1: "المحامون،",
      title2: "بالأسماء.",
      full: "الفريق الكامل",
    },
    testimonials: {
      eyebrow: "ثقة العملاء",
      title1a: "موثوقون",
      title1b: "بهدوء",
      title2: "، وبانتظام.",
    },
    matters: {
      eyebrow: "مواقف مختارة",
      title1: "العمل،",
      title2: "في السجلّ.",
      lead: "قائمة موجزة وغير حصرية من المواقف التي تُظهر نطاق الممارسة. أسماء العملاء محفوظة بموجب الواجب المهنيّ.",
      all: "عرض جميع المواقف",
    },
    insights: {
      eyebrow: "أحدث المقالات",
      title1: "قراءة،",
      title2: "بين السطور.",
      all: "جميع المقالات",
      featured: "المميّز",
      read: "قراءة المقال",
      back: "العودة إلى المقالات",
    },
    clients: { eyebrow: "عملاء مختارون" },
    contactCTA: {
      title1: "ابدأ",
      title2: "تعاوناً.",
      lead: "محادثةٌ أوليّة سرّية بلا التزام، عادةً خلال يوم عمل واحد.",
      cta: "تواصل مع المكتب",
    },
    contact: {
      eyebrow: "اطلب استشارة",
      title1: "ابدأ",
      title2: "تعاوناً.",
      lead: "محادثة أولى سرّية بلا التزام. كلّ رسالة يقرأها شريك، عادةً خلال يوم عمل واحد.",
      name: "٠١، الاسم الكامل",
      namePh: "اسمك",
      email: "٠٢، البريد الإلكتروني",
      emailPh: "you@example.com",
      business: "٠٣، العمل (اختياري)",
      businessPh: "الشركة / المؤسسة",
      message: "٠٤، الرسالة",
      messagePh: "أخبرنا باختصار عمّا يقودك إلى المكتب.",
      submit: "أرسل الرسالة",
      sending: "جارٍ الإرسال…",
      sent: "أُرسلت",
      chambers: "المكاتب",
      direct: "مباشر",
      err: "الاسم والبريد والرسالة حقول مطلوبة.",
      okTitle: "استُلمت",
      okBody: "سيتواصل معك أحد الشركاء قريباً.",
      disclaimer: "بإرسالك هذه الرسالة، تُقرّ بأنّ هذا الموقع لا يُنشئ علاقة محامٍ–موكّل.",
      toastOk: "تم استلام الرسالة. سيردّ أحد الشركاء خلال يوم عمل واحد.",
      toastFail: "تعذّر الإرسال. يُرجى المحاولة مرة أخرى.",
    },
    about: {
      eyebrow: "RPLC UAE · مكتب رانِه بينغل للمحاماة",
      title1: "قانون × تكنولوجيا ×",
      title2: "تنظيم × أعمال.",
      lead1: "RPLC UAE مكتب استشارات قانونيّة وأعماليّة حديث يعمل على تقاطع القانون × التكنولوجيا × التنظيم × الأعمال.",
      lead2: "نقدّم الاستشارة للمؤسسين والشركات التقنيّة والماليّة والشركات متعددة الجنسيات العاملة في وعبر الإمارات، بجمع خبرة تنظيميّة عميقة وفهم للواقع التجاريّ الذي يُشكّل الاقتصاد الرقميّ.",
      lead3: "يمتدّ حضورنا عبر الإمارات والهند والولايات المتحدة، بتوفير دعم قانونيّ منسّق للأعمال أثناء توسّعها واستثمارها وتشغيلها. تُقدَّم الأعمال الدوليّة كاستشارة عبر الحدود وتنسيق مع مستشارين محلّيّين حيثما تقتضي القوانين المعمول بها.",
      stats: [
        { n: "٠٣", l: "ولايات قضائية" },
        { n: "١٥", l: "مجالات ممارسة" },
        { n: "٠٢", l: "الشركاء المؤسّسون" },
        { n: "٠٣", l: "شركاء المرافعة المحلّيّون" },
      ],
      offices: { eyebrow: "الحضور العالمي", title1: "ثلاث أسواق،", title2: "ملفٌّ واحد." },
    },
    practicePage: {
      eyebrow: "مجالات الخبرة · ١٥",
      title1: "خمسة عشر تخصصاً،",
      title2: "منصة واحدة.",
      lead: "كلّ ملفّ يعمل عليه شريك مع فريق صغير مخصّص. لا يُمرَّر ملفٌّ جانبيّاً، المحامي الذي كلّفته هو المحامي الذي يبقى معك.",
      close: "محادثة أولى سرّية.",
    },
    practiceDetail: {
      back: "جميع مجالات الممارسة",
      overview: "نظرة عامة",
      howWeWork: "كيف نعمل",
      services: "ما نقوم به",
      matters: "قضايا إرشادية",
      mattersNote: "أسماء العملاء محفوظة بموجب الواجب المهنيّ؛ التفاصيل إرشادية.",
      faqs: "الأسئلة الشائعة",
      lead: "رئيس الممارسة",
      profile: "عرض الملف",
      related: "مجالات ممارسة ذات صلة",
      reading: "قراءات ذات صلة",
      focus: "التركيز",
      ctaTitle1: "تحدّث مع",
      ctaTitle2: "الفريق.",
      ctaLead: "محادثة أولى سرّية بلا التزام، عادةً خلال يوم عمل واحد. الحالات العاجلة تُعالَج في اليوم نفسه.",
      cta: "تواصل مع المكتب",
      direct: "مباشر",
      explore: "استكشف الممارسة",
    },
    teamPage: {
      eyebrow: "الفريق · الشركاء والمستشارون",
      title1: "المحامون،",
      title2: "بالأسماء.",
      close: "كلّف الفريق.",
    },
    footer: {
      eyebrow: "قانون × تكنولوجيا × تنظيم × أعمال",
      title1: "استشارة،",
      title2: "بوضوح",
      title3: "منسّقة.",
      lead: "RPLC UAE مكتب استشارات قانونيّة وأعماليّة حديث يعمل على تقاطع القانون × التكنولوجيا × التنظيم × الأعمال، عبر الإمارات والهند والولايات المتحدة. يُقدَّم التمثيل الرسميّ أمام السلطات الإماراتيّة عبر شركاء المرافعة الإماراتيّين المسجّلين.",
      cta: "ابدأ تعاوناً",
      practice: "الممارسات",
      offices: "المكاتب",
      disclaimer: "وفقاً لقواعد نقابة المحامين، هذا الموقع لأغراض إعلامية فقط ولا يُعدّ ترويجاً أو إعلاناً. لا يُنشئ أي محتوى فيه علاقة محامٍ–موكّل.",
    },
  },
};
